import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { GET_USER_INFO } from '@/src/common/gql/queries/user'
import * as Mortgage from '@/src/experiences/mortgage'
import { useLogError } from './useLogError'
import { useMemo } from 'react'

export function useSourcePartnerName() {
  const onError = useLogError()

  const {
    data: userData,
    loading,
    error,
  } = useLoggedInQuery(GET_USER_INFO, {
    onError,
  })

  const sourcePartnerName: Mortgage.Statsig.Store.MortgageModuleVariantName = useMemo(() => {
    const sourcePartnerName = userData?.getUserInfo.sourcePartnerName?.toLowerCase()
    if (!sourcePartnerName) {
      return 'default'
    }
    try {
      return Mortgage.Statsig.Store.MortgageModuleVariantName.parse(sourcePartnerName)
    } catch (_) {
      return 'default'
    }
  }, [userData?.getUserInfo.sourcePartnerName])

  return {
    sourcePartnerName,
    loading,
    error,
  } as const
}
